import { plainToClass } from 'class-transformer';
import { ulid } from 'ulid';
import Location from './Location';

export default class Agent {
  public activeLocations?: Location[] | null;

  public asab?: string[] | null;

  public bio?: string | null;

  public cityState: string;

  public email: string;

  public facebook?: string | null;

  public firstName: string;

  /** full name using preferred name if present */
  public get fullName(): string {
    return `${this.preferredName || this.firstName} ${this.lastName}`.replace(/\b(\w+)(?:\W+\1\b)+/g, '$1');
  }

  public id: string;

  public languages: string[];

  public lastName: string;

  public linkedIn?: string | null;

  /** preferred name or first name */
  public get name(): string {
    if (!this.preferredName) {
      return this.firstName;
    }

    return this.preferredName.replace(this.lastName, '').trim();
  }

  public get facebookUrl(): string {
    if (this.facebook) {
      if (this.facebook.startsWith('http')) {
        return this.facebook;
      }
      return `https://${this.facebook}`;
    }
    return '';
  }

  public get twitterUrl(): string {
    if (this.twitter) {
      if (this.twitter.startsWith('http')) {
        return this.twitter;
      }
      if (this.twitter.startsWith('@') || !this.twitter.startsWith('https://www.twitter.com') || !this.twitter.startsWith('www.twitter.com')) {
        return `https://www.twitter.com/${this.twitter}`;
      }
      if (this.twitter.startsWith('www')) {
        return `https://${this.twitter}`;
      }
      return `https://${this.twitter}`;
    }
    return '';
  }

  public get linkedInUrl(): string {
    if (this.linkedIn) {
      if (this.linkedIn.startsWith('http')) {
        return this.linkedIn;
      }
      return `https://${this.linkedIn}`;
    }
    return '';
  }

  public phoneNumber: string;

  public photo?: string | null;

  public specializations: string[];

  public state: string;

  public stateBroker?: string[] | null;

  public preferredName?: string | null;

  public get title(): string {
    if (this.stateBroker?.length && this.asab?.length) {
      return `Designated Managing Broker - ${this.stateBroker.join(', ')} / Managing Broker - ${this.asab.join(', ')}`;
    }

    if (this.stateBroker?.length) {
      return `Designated Managing Broker - ${this.stateBroker.join(', ')}`;
    }

    if (this.asab?.length) {
      return `Managing Broker - ${this.asab.join(', ')}`;
    }

    return `${this.cityState} Real Estate Agent`;
  }

  public twitter?: string | null;

  public website?: string | null;

  public isBroker(): boolean {
    return Boolean(this.asab?.length || this.stateBroker?.length);
  }

  static deserialize(agent: Partial<Agent>): Agent {
    const a = plainToClass(Agent, agent);
    a.id = a.id || ulid();
    return a;
  }
}
